import { cva } from "class-variance-authority"

const size = {
  large: "font-large-525 text-general-primary-text",
  medium: "font-medium-525 text-general-secondary-text",
}

export const labelSizeVariantKeys = Object.keys(size)

export const labelVariants = cva(
  "inline-block leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      size,
      v2: {
        true: "aria-disabled:cursor-not-allowed aria-disabled:text-icon-general-disabled",
      },
    },
  }
)
